/*
 * Exports dashboards by name.
 * The mapping from strings to JSX components is handled here.
 * For a dashboard JSX file to be referenced by name in dashboards.json, it must be specifically exported here.
 *
 * Dashboards are dynamically imported using asyncComponent() if they use the react-timeseries-charts library.
 * This is because react-timeseries-charts drags in a lot of JavaScript dependencies.
 * When the build script compiles the bundle into chunks, these dashboards will land in a separate chunk that
 * most dashboards won't need to load.
 */
import Adapt from './general/Adapt';
import CmsTopHits from './cms/CmsTopHits';
import ConvivaDanySummary from './general/ConvivaDanySummary';
import ConvivaSummary from './general/ConvivaSummary';
import Clock from './general/Clock';
import DeviceCountGross from './viewership/DeviceCountGross';
import Dynapub from './dyna/Dynapub';
import Epg from './epg/Epg';
import ErrorCodes from './errors/ErrorCodes';
import Playback from './rsdvr/Playback';
import PrimeTimeDevices from './general/PrimeTimeDevices';
import RabbitMQ from './rsdvr/RabbitMQ';
import Recordings from './rsdvr/Recordings';
import Summary from './general/Summary';
import Sundial from './misc/Sundial';
import SVODReport from './cms/SVODReport';
import TopErrorsByDeviation from './errors/TopErrorsByDeviation';
import NewRelicIncidentByPolicy from './errors/NewRelicIncidentByPolicy';
import NewReleases from './misc/NewReleases';

import WeekOverWeekCDN from './viewership/WeekOverWeekCDN';
import Zenoss from './alerts/Zenoss';
import NewRelicZenoss from './alerts/NewRelicZenoss';

import ViewershipSparklines from './viewership/ViewershipSparklines';

import ScatterplotTester from './experimental/ScatterplotTester';
import RawJson from './experimental/RawJson';
import ServiceComponents from './jira/ServiceComponents';
import ServiceComponentAnimation from './jira/ServiceComponentAnimation';
import Debug from './experimental/Debug';
import Zen from './misc/Zen';

import asyncComponent from '../asyncComponent';

export default ({
    Adapt,
    AdBreaks: asyncComponent(() => import('./ads/AdBreaks')),
    CDN: asyncComponent(() => import('./cdn/CDN')),
    ClientErrors: asyncComponent(() => import('./errors/ClientErrors')),
    Clock,
    Cms: asyncComponent(() => import('./cms/Cms')),
    CmsGross: asyncComponent(() => import('./cms/CmsGross')),
    CmsTopHits,
    ConvivaDanySummary,
    ConvivaSummary,
    DeviceCountDeviations: asyncComponent(() => import('./viewership/DeviceCountDeviations')),
    DeviceCountGross,
    DownDetector: asyncComponent(() => import('./general/DownDetector')),
    Dynapub,
    Epg,
    ErrorCodes,
    Playback,
    PrimeTimeDevices,
    RabbitMQ,
    Recordings,
    ServiceComponents,
    ServiceComponentAnimation,
    Summary,
    SVODReport,
    TopErrorsByDeviation,
    NewRelicIncidentByPolicy,
    WeekOverWeekViewership: asyncComponent(() => import('./viewership/WeekOverWeekViewership')),
    LongTermViewership: asyncComponent(() => import('./viewership/LongTermViewership')),
    WeekOverWeekCDN,
    Zenoss,
    NewRelicZenoss,
    NewReleases,
    ViewershipSparklines,
    Tableau: asyncComponent(() => import('./tableau/Tableau')),

    ScatterplotTester,
    RawJson,
    ChartWidgets: asyncComponent(() => import('./experimental/ChartWidgets')),
    Debug,
    Zen,
    Sundial,
});

